module.exports = __webpack_public_path__ + "img/icon4.13d2cb77.png";